import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Mail, Phone, MapPin, Building2 } from 'lucide-react';

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#0A0E1A]">
      <Navbar />
      
      <section className="py-20 px-6" data-testid="contact-section">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold tracking-tighter uppercase mb-12 text-center">
            <span className="text-white">CONTACT </span>
            <span className="text-[#00A6E8]">US</span>
          </h1>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Contact Info */}
            <div className="bg-[#0F172A] border border-white/10 rounded-lg p-8" data-testid="contact-info">
              <h2 className="text-2xl font-bold mb-6 text-white uppercase">Get In Touch</h2>
              
              <div className="space-y-6">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <Building2 className="text-[#00A6E8]" size={24} />
                    <h3 className="text-white font-semibold">Company</h3>
                  </div>
                  <p className="text-slate-300 ml-9">Fallou Enterprise INC</p>
                  <p className="text-slate-400 ml-9 text-sm">Manager</p>
                </div>
                
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <MapPin className="text-[#00A6E8]" size={24} />
                    <h3 className="text-white font-semibold">Location</h3>
                  </div>
                  <p className="text-slate-300 ml-9">Based in Columbus, Ohio</p>
                </div>
                
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <Phone className="text-[#00A6E8]" size={24} />
                    <h3 className="text-white font-semibold">Phone</h3>
                  </div>
                  <p className="text-slate-300 ml-9">Office: +1 (614) 778 8307</p>
                  <p className="text-slate-300 ml-9">Mobile: +1 (614) 598 6668</p>
                </div>
                
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <Mail className="text-[#00A6E8]" size={24} />
                    <h3 className="text-white font-semibold">Email</h3>
                  </div>
                  <p className="text-slate-300 ml-9">mdiouf@fallouenterprise.com</p>
                  <p className="text-slate-400 ml-9 text-sm mt-2">Operations: fallouenterprise@gmail.com</p>
                </div>
              </div>
            </div>
            
            {/* Credentials */}
            <div className="bg-[#0F172A] border border-white/10 rounded-lg p-8" data-testid="credentials">
              <h2 className="text-2xl font-bold mb-6 text-white uppercase">Credentials</h2>
              
              <div className="space-y-6">
                <div className="p-6 bg-[#1E293B] rounded-lg border border-white/5">
                  <p className="text-slate-400 text-sm mb-2">US DOT Number</p>
                  <p className="text-4xl font-bold text-[#00A6E8]">1662372</p>
                </div>
                
                <div className="p-6 bg-[#1E293B] rounded-lg border border-white/5">
                  <p className="text-slate-400 text-sm mb-2">MC Number</p>
                  <p className="text-4xl font-bold text-[#FFA726]">657445</p>
                </div>
              </div>
              
              <div className="mt-8 p-6 bg-[#00A6E8]/10 border border-[#00A6E8]/20 rounded-lg">
                <p className="text-slate-300 text-sm leading-relaxed">
                  Ready to streamline your logistics? Create an account or contact us directly to discuss your container drayage needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}